import { Button } from '@platform/components';
import { isTypeSmallCta, TypeSmallCtaSkeleton } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulSmallCta = ({
  entry,
}: {
  entry: Entry<TypeSmallCtaSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeSmallCta(entry)) {
    return null;
  }

  {
    /* TODO: Map out the CTA types and sizes */
  }
  return (
    <div className='w-fit'>
      <Button
        variant='primary'
        size='lg'
        href={entry.fields.url}
        target={entry.fields.openInNewTab ? '_blank' : '_self'}
      >
        {entry.fields.text}
      </Button>
    </div>
  );
};

export default ContentfulSmallCta;
